import { gql } from '@apollo/client';
import { graphqlClient } from 'spw-api/utils';
import { Headcount } from 'spw-redux/modules/projects/types';

export const updateHeadcounts = (headcounts: Headcount[]) => {
  return graphqlClient.mutate({
    mutation: gql`
      mutation UpdateHeadcounts($headcounts: [HeadcountArgs!]!) {
        headcounts: updateHeadcounts(headcounts: $headcounts) {
          client
          architect
          buildingId
          floorId
        }
      }
    `,
    variables: {
      headcounts,
    },
  });
};
